import {defineStore} from "pinia";

export const useProductStore = defineStore("product", {
  state: () => ({
    productConfig: {
      voteInfo: {} // 投票静态配置信息介绍
    },
    productIdLastVisit: "",
    isShowDrawerProductVoteCreator: false,
    isShowDrawerProductVotePlayer: false,
    isVote: false, // 通过投票详情弹窗，直接打开投票分享 非产品分享
    voteRole: 0, // 1 creator 2 player
    voteData: {},
  }),
  getters: {
    getterProductConfig(state) {
      return state.productConfig
    },
    getterProductIdLastVisit(state) {
      return state.productIdLastVisit
    },
    getterIsShowDrawerProductVoteCreator(state) {
      return state.isShowDrawerProductVoteCreator
    },
    getterIsShowDrawerProductVotePlayer(state) {
      return state.isShowDrawerProductVotePlayer
    },
    getterIsVote(state) {
      return state.isVote
    },
    getterVoteRole(state) {
      return state.voteRole
    },
    getterVoteData(state) {
      return state.voteData
    },
  },
  actions: {
    updateProductConfig(productConfig) {
      this.productConfig = productConfig
    },
    updateProductIdLastVisit(productIdLastVisit) {
      this.productIdLastVisit = productIdLastVisit
    },
    updateIsShowDrawerProductVoteCreator(isShowDrawerProductVoteCreator) {
      this.isShowDrawerProductVoteCreator = isShowDrawerProductVoteCreator
    },
    updateIsShowDrawerProductVotePlayer(isShowDrawerProductVotePlayer) {
      this.isShowDrawerProductVotePlayer = isShowDrawerProductVotePlayer
    },
    updateIsVote(isVote) {
      this.isVote = isVote
    },
    updateVoteRole(voteRole) {
      this.voteRole = voteRole
    },
    updateVoteData(voteData) {
      this.voteData = voteData
    },
  },
  persist: {
    paths: []
  }
})
